import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col, Affix, Input } from 'antd'; // <-- Import AntD Input
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { Delete, Trash } from 'lucide-react';

import useChatbox from '../useChatbox';
import PortfolioPicker from '../../../Search/PortfolioSearch/PortfolioPicker';
import { selectAllConversations } from '../../../../store/slices/gpt.slice';

const ChatTools = ({
  responseId,
  onRenameConversation,
  onClearConversation,
  conversationTitle, // The current title from the parent
}) => {
  const [title, setTitle] = useState(conversationTitle || '');
  const { portfolioDocument, handleSelectPortfolio } = useChatbox();
  const allConversations = useSelector(selectAllConversations);

  useEffect(() => {
    setTitle(conversationTitle || '');
  }, [conversationTitle]);

  const handleTitleBlur = () => {
    if (title.trim() !== conversationTitle) {
      onRenameConversation(title.trim());
    }
  };

  return (
    <Affix offsetTop={0}>
      <div className="px-12 bg-white">
        <Row align="top" justify="space-between" gutter={16}>
          {/* Left Column: Title and Action Buttons */}
          <Col style={{ display: 'flex', alignItems: 'center' }}>
            <Input
              placeholder="Conversation Title"
              value={title}
              size="small"
              onChange={(e) => setTitle(e.target.value)}
              onBlur={handleTitleBlur}
              style={{
                marginRight: '0.5rem',
                minWidth: '220px',
              }}
            />
            <span className="text-xs font-medium text-gray-500 mr-6">
              Rename
            </span>

            <IconButton color="error" onClick={onClearConversation}>
              <Trash size={18} />
            </IconButton>
          </Col>

          {/* Right Column: Portfolio Picker */}
          <Col>
            <Row gutter={4} align="middle">
              <Col>
                <PortfolioPicker
                  onSelect={(portfolio) =>
                    handleSelectPortfolio(portfolio, allConversations)
                  }
                  allowTypes={['b', 's', 'm']}
                  text={
                    portfolioDocument ? <SwapHorizIcon /> : 'Select Portfolio'
                  }
                  variant={portfolioDocument ? 'contained' : 'text'}
                />
              </Col>

              {portfolioDocument && (
                <Col style={{ fontSize: '0.95rem', fontWeight: 500 }}>
                  {portfolioDocument.name}
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </div>
    </Affix>
  );
};

export default ChatTools;
